import { Container } from "./styles"
import coinImg from '../../assets/coin.png'
export function Header () {
    return (
        <Container>
            <div>
                <img src={coinImg} alt="coin" />
                <h2>Conversion Money</h2>
            </div>
        </Container>
    )
}